import { HistoryItem } from '../history';
import { DsiIssue } from './dsiIssue';
import { z } from 'zod';

export type DsiSessionStatus = z.infer<typeof DsiSessionStatus>;
export type DsiSession = z.infer<typeof DsiSession>;
export type DsiLock = z.infer<typeof DsiLock>;

export const DsiSessionStatus = z.enum([
    'notEdited',
    'OK',
    'locked',
    'irregularity',
    'notReviewableTech',
    'notReviewableContent',
    'inquiry',
]);

export const DsiSession = z.object({
    storeGuid: z.string(),
    sessionGuid: z.string(),
    customerGuid: z.string().nullish(),
    sessionStartedOn: z.coerce.date().nullish(),

    status: DsiSessionStatus,
    statusDetails: z.string().array(),
    issues: DsiIssue.array(),
    comment: z.string().nullish(),
    history: HistoryItem.array().nullish(),

    lockedOn: z.coerce.date().nullish(),
    lockedBy: z.string().nullish(),
    modifiedOn: z.coerce.date().nullish(),
    analyzedOn: z.coerce.date().nullish(),
});

export const DsiLock = DsiSession.pick({
    lockedOn: true,
    lockedBy: true,
});
